import { createContext } from "react";

const appContext = createContext({
  originSchools: [],
  setOriginSchools: () => {},
  schools: [],
  setSchools: () => {},
  stations: {},
  gradeFilters:[],
  setGradeFilters: () => {},
  wardFilters:[],
  setWardFilters: () => {},
  offeringSorts: [],
  setOfferingSorts:() => {},
  loadingData: false,
  setLoadingData:() => {},
  searchedPlace: null,
  setSearchedPlace:() => {},
  selectedSchool: "",
  setSelectedSchool:() => {},
  inBoundaryFilter: false,
  setInBoundaryFilter:() => {},
  boundaryPolys: [],
  setBoundaryPolys: () => {},
  locale: 'en',
  setLocale: () => {},
  filterInit: false,
  setFilterInit: () => {}
});

export default appContext;
